import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { KnBrCustomerContextService } from '../store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrQuoteContextService } from '../store/kn-br-quote-context/kn-br-quote-context.service';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Observable } from 'rxjs';
import { KN_BR_CUSTOMER_CURRENT, KNBR_SHIPPING_DETAILS, KNBR_SET_BILLING_ADDRESS, KNBR_PLACEORDER, KNBR_CART_SET_PO_NUMBER, KNBR_CART_ENTRY_OVERLIMIT_COMMENT, KNBR_LABELS_PLANT_LOCATIONS, KNBR_PLACEORDER_RFQ } from 'src/constants/api.endpoints.constant';

@Injectable({
  providedIn: 'root',
})
export class KnBrSalesCheckoutService {
  customerId: string;
  cartId: string;
  orderConfirmationData:string;

  constructor(private endPointService: OccEndpointsService,
    private httpClient: HttpClient,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected knBrQuoteContextService: KnBrQuoteContextService,
    protected activeCartService: ActiveCartService) {

    this.activeCartService.getActiveCartId().subscribe((response) => {
      if (response) {
        this.cartId = response ? response : null;
      }
    });
    this.knBrCustomerContextService
      .getActiveCustomerNumber()
      .subscribe((response) => {
        this.customerId = response ? response : KN_BR_CUSTOMER_CURRENT;
      });
  }

  updatePONumber(poNumber: string): Observable<any> {
    const url = this.endPointService.buildUrl(KNBR_CART_SET_PO_NUMBER, {
      urlParams: {
        customerId: this.customerId || 'current',
        cartId: this.cartId,
      },
      queryParams: {
        poNumber: poNumber,
      },
    });
    return this.httpClient.put(url, null);
  }

  updateOverlimitComment(entryNumber: string, comment: string, isRFQ:boolean=false): Observable<any> {
    const url = this.endPointService.buildUrl(KNBR_CART_ENTRY_OVERLIMIT_COMMENT, {
      urlParams: {
        customerId: this.customerId || 'current',
        cartId: this.cartId,
        entryNumber: entryNumber,
      },
      queryParams: {
        comment: comment,
        isRFQ: isRFQ,
      },
    });
    return this.httpClient.patch(url, null);
  }

  getLabelsPlantLocations(cartId: string = this.cartId): Observable<any> {
    const url = this.endPointService.buildUrl(KNBR_LABELS_PLANT_LOCATIONS, {
      urlParams: {
        customerId: this.customerId || KN_BR_CUSTOMER_CURRENT,
        cartId,
      },
    });
    return this.httpClient.get(url);
  }


  shippingDetails(payload: any,isRFQ:boolean=false): Observable<any> {
    const url = this.endPointService.buildUrl(
      KNBR_SHIPPING_DETAILS(this.customerId, this.cartId, isRFQ)
    );
    return this.httpClient.post(url, payload);
  }

  setDeliveryAddress(payload: any): Observable<any> {
    const url = this.endPointService.buildUrl(
      KNBR_SET_BILLING_ADDRESS(this.customerId, this.cartId)
    );
    return this.httpClient.put(url, payload);
  }

  placeOrder(): Observable<any> {
    const url = this.endPointService.buildUrl(
      KNBR_PLACEORDER(this.customerId, this.cartId)
    );
    return this.httpClient.post(url, {});
  }
  setOrderConfirmData(data:any){
    this.orderConfirmationData = data;
  }
  getOrderConfirmData(){
    return this.orderConfirmationData
  }

  placeOrderRFQ(): Observable<any> {
    const url = this.endPointService.buildUrl(
      KNBR_PLACEORDER_RFQ(this.customerId, this.cartId)
    );
    return this.httpClient.post(url, {});
  }

  resolveImageUrl(item: any): string {
    const images = item?.product?.images;
    if (!images) {
      return '';
    }

    if (Array.isArray(images)) {
      const primary = images.find((img) => String(img?.imageType || '').toUpperCase() === 'PRIMARY') || images[0];
      if (Array.isArray(primary?.formats)) {
        const preferredFormat = primary.formats.find((f) => ['cartIcon', 'thumbnail', 'product', 'zoom'].includes(f?.qualifier || f?.format)) || primary.formats[0];
        return preferredFormat?.url || '';
      }
      return primary?.url || '';
    }

    const primary = images?.PRIMARY || images?.primary || images;
    return (
      primary?.cartIcon?.url ||
      primary?.thumbnail?.url ||
      primary?.product?.url ||
      primary?.zoom?.url ||
      primary?.url ||
      ''
    );
  }
}
